import { render, staticRenderFns } from "./Double12_2021.vue?vue&type=template&id=1ad67d98&scoped=true&"
import script from "./Double12_2021.vue?vue&type=script&lang=js&"
export * from "./Double12_2021.vue?vue&type=script&lang=js&"
import style0 from "./Double12_2021.vue?vue&type=style&index=0&id=1ad67d98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad67d98",
  null
  
)

export default component.exports